module.exports = __webpack_public_path__ + "static/img/32政文.9493c8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/32政文.jpg
// module id = 0QFM
// module chunks = 0